<template>
  <m-dialog
    ref="dlg"
    @save="save"
    :title="tenant && tenant.no_reg ? 'Ubah Tenant' : 'Tambah Tenant'"
  >
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <span class="title primary--text">Data Tenant</span>
            <v-row wrap>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Nama Tenant</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  autofocus
                  label="Nama Tenant*"
                  v-model="tenant.nama"
                  hint="Nama Tenant"
                  data-vv-name="nama"
                  data-vv-as="Nama Tenant"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.nama')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Surel Tenant</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Surel Tenant*"
                  v-model="tenant.email"
                  hint="Masukkan Surat Elektronik Tenant"
                  data-vv-name="email"
                  data-vv-as="Surel Tenant"
                  v-validate="'email'"
                  :error-messages="errors.collect('form.email')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                <label class="caption">Alamat</label>
                <v-textarea
                  dense
                  single-line
                  outlined
                  label="Alamat"
                  v-model="tenant.alamat"
                  hint="Alamat"
                  data-vv-name="alamat"
                  data-vv-as="Alamat"
                  v-validate
                  rows="2"
                  :error-messages="errors.collect('form.alamat')"
                ></v-textarea>
              </v-col>
            </v-row>
            <span class="title primary--text" v-show="editable"
              >Data Admin Tenant</span
            >
            <v-row v-show="editable">
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Nama User</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Nama*"
                  v-model="tenant.nama_user"
                  hint="Nama"
                  data-vv-name="nama_user"
                  data-vv-as="Nama"
                  v-validate="editable ? 'required' : ''"
                  :error-messages="errors.collect('form.nama_user')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Jenis Kelamin</label>
                <v-select
                  dense
                  single-line
                  outlined
                  :items="KELAMIN"
                  item-text="label"
                  item-value="id"
                  v-model="tenant.gender_user"
                  label="Jenis Kelamin"
                  data-vv-name="gender_user"
                  data-vv-as="Jenis Kelamin"
                  v-validate="editable ? 'required' : ''"
                  :error-messages="errors.collect('form.gender_user')"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Surel</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Surel*"
                  v-model="tenant.email_user"
                  hint="Surel"
                  data-vv-name="email_user"
                  data-vv-as="Surel"
                  v-validate="editable ? 'required|email' : ''"
                  :error-messages="errors.collect('form.email_user')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">No Telp</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Nomor Telp"
                  v-model="tenant.no_hp_user"
                  hint="Nomor Telepon"
                  data-vv-name="no_hp_user"
                  data-vv-as="Nomor Telp"
                  v-validate="editable ? 'min:6|max:14' : ''"
                  :error-messages="errors.collect('form.no_hp_user')"
                  :autocomplete="false"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Kata Sandi</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  v-if="!tenant.no_reg"
                  ref="password"
                  type="password"
                  label="Kata Sandi"
                  v-model="tenant.password_user"
                  hint="Kata Sandi"
                  data-vv-name="password_user"
                  data-vv-as="Kata Sandi"
                  v-validate="editable ? 'required|min:6' : ''"
                  :error-messages="errors.collect('form.password_user')"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                <label class="caption">Konfirmasi Kata Sandi</label>
                <v-text-field
                  dense
                  single-line
                  outlined
                  v-if="!tenant.no_reg"
                  type="password"
                  label="Konfirmasi Kata Sandi"
                  v-model="tenant.password_confirmation"
                  hint="Konfirmasi password"
                  data-vv-name="password_confirmation"
                  data-vv-as="Konfirmasi Kata Sandi"
                  v-validate="
                    editable ? 'required|min:6|confirmed:password' : ''
                  "
                  :error-messages="errors.collect('form.password_confirmation')"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
import { KELAMIN } from "@/const";
export default {
  $_veeValidate: {
    validator: "new"
  },

  data() {
    return {
      roles: [],
      tenant: {},
      editable: true,
      defTenant: {
        nama: null,
        email: null,
        alamat: null,
        no_hp_user: "+62"
      },
      KELAMIN: KELAMIN
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.$validator.reset();
      this.tenant = obj
        ? { ...obj, ...(this.editable = false) }
        : { ...this.defTenant, ...(this.editable = true) };
      return this.$refs.dlg.open();
    },
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          return this.$store.dispatch("tenant/form", this.tenant);
        })
        .then(res => {
          this.$refs.dlg.resolve();
          return res;
        })
        .catch(e => e);
    }
  }
};
</script>
